import Quicksand from '../../assets/fonts/Quicksand-VariableFont_wght.ttf';
import Roboto from '../../assets/fonts/Roboto-Regular.ttf';
import Lato from '../../assets/fonts/Lato-Regular.ttf';
import Montserrat from '../../assets/fonts/Montserrat-Regular.ttf';
import Poppins from '../../assets/fonts/Poppins-Regular.ttf';
import Nunito from '../../assets/fonts/Nunito-Regular.ttf';
import PlayfairDisplay from '../../assets/fonts/PlayfairDisplay-Regular.ttf';
import Raleway from '../../assets/fonts/Raleway-Regular.ttf';
import Merriweather from '../../assets/fonts/Merriweather-Regular.ttf';
import Ubuntu from '../../assets/fonts/Ubuntu-Regular.ttf';
import PTSans from '../../assets/fonts/PTSans-Regular.ttf';
import Oswald from '../../assets/fonts/Oswald-Regular.ttf';
import Verdana from '../../assets/fonts/verdana.ttf';
import OpenSans from '../../assets/fonts/OpenSans/OpenSans-VariableFont_wdth.ttf';
import TimesNewRoman from '../../assets/fonts/times-new-roman.ttf';
import Arial from '../../assets/fonts/arial.ttf';
import Helvetica from '../../assets/fonts/Helvetica.ttf';
import Georgia from '../../assets/fonts/Georgia.ttf';
import {Font} from '../incase-domain/presentationTheme';

export const defaultFonts: Font[] = [
    {name: 'Arial', url: Arial, selected: false},
    {name: 'Times New Roman', url: TimesNewRoman, selected: false},
    {name: 'Helvetica', url: Helvetica, selected: false},
    {name: 'Georgia', url: Georgia, selected: false},
    {name: 'Open Sans', url: OpenSans, selected: false},
    {name: 'Verdana', url: Verdana, selected: false},
    {name: 'Roboto', url: Roboto, selected: false},
    {name: 'Lato', url: Lato, selected: false},
    {name: 'Montserrat', url: Montserrat, selected: false},
    {name: 'Poppins', url: Poppins, selected: false},
    {name: 'Nunito', url: Nunito, selected: false},
    {name: 'Playfair Display', url: PlayfairDisplay, selected: false},
    {name: 'Raleway', url: Raleway, selected: false},
    {name: 'Merriweather', url: Merriweather, selected: false},
    {name: 'Ubuntu', url: Ubuntu, selected: false},
    {name: 'PT Sans', url: PTSans, selected: false},
    {name: 'Quicksand', url: Quicksand, selected: false},
    {name: 'Oswald', url: Oswald, selected: false},
];

export function addFontFamilyToHead(font: Font): () => void {
    const existingStyle = document.getElementById(font?.name);
    const style = document.createElement('style');
    if (!existingStyle) {
        style.id = `presTheme - fontFamily - ${font?.name}`;
        style.innerHTML = `
                    @font-face {
                      font-family: '${font?.name}';
                      src: url('${font?.url}') format('opentype');
                    }
                  `;
        document.head.appendChild(style);
    }
    return () => {
        document.head.removeChild(style);
    };
}
